import React from 'react';
import styleBottom from  '../../style/bottomSheet.module.css';
import style from '../../style/startEvent.module.css';


function StartEvent(props){
      return(
          <>
              <div className={styleBottom.switchLine}></div>
              <div className={style.event}>
                    <h4>3:00PM</h4>
                    <h2>Sacred Cypher Sundays</h2>
                    <img src="https://images.unsplash.com/photo-1584997159889-8bb96d0a2217?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8aHVtYW58ZW58MHwyfDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60" alt='member'/>
                    <img src="https://images.unsplash.com/photo-1584518969469-c2d99c7760a0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8aHVtYW58ZW58MHwyfDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60" alt='member' className='mx-1'/>
                    <img src="https://media-exp1.licdn.com/dms/image/C4D03AQGbnF1zOfSPkA/profile-displayphoto-shrink_200_200/0/1607464988830?e=1659571200&v=beta&t=PrCCqls7_Xufvr78jODsA0Gghi_62pbJ3IT6CtP1X1E" alt='member' className='mx-1'/>
                    <img src="https://images.unsplash.com/photo-1622012070740-4f753ebb9bad?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fGh1bWFufGVufDB8MnwwfHw%3D&auto=format&fit=crop&w=500&q=60" alt='member'/>
                    <p className='mt-2'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</p>
              </div>
              <div className="text-center">
                  <button className={styleBottom.letGoBtn}
                  onClick={()=>{
                      props.setSheetCreateRoom(true);
                      props.setSheetVisible(true);
                  }}>Join the room in progress</button>
              </div>
          </>
      )
}
export default StartEvent;